import React, { useState, useEffect } from 'react';
import './style.css';
import { useParams } from 'react-router-dom';
import { useDocument } from '../../Pages/SpreadsheetContainer/documentInfoContex';
import { loadServerData, updateAllSheets } from '../../utils/api';
import { removeOfflineData } from '../../x-data-spreadsheet/src/utils/helper';
import { isEffectivelyOffline } from '../../utils/helper';

const OfflineStatus = () => {

  const { id } = useParams();
  const { setSavingData, setIsConflictModalVisible, setServerData, isManualOffline } = useDocument();
  const [offline, setOffline] = useState(isEffectivelyOffline());

  useEffect(() => {
    const handleOfflineStatus = async () => {

      // "Online" here means we should actually talk to the server, so a manual
      // work-offline choice counts as offline for syncing too — not just display.
      const isOnline = !isEffectivelyOffline();
      setOffline(!isOnline);

      const offlineBoard = JSON.parse(localStorage.getItem('offlineSheets') || '{}');
      const localData = offlineBoard[id]?.data || null;
      const localUpdateTime = offlineBoard[id]?.lastUpdateTime || null;


      if (isOnline && localData) {
        try {

          //server data
          const serverData = await loadServerData(id);
          const serverSheetsData = serverData?.spreadsheetData || [];
          const serverUpdateTime = serverData?.updatedAt || null;
          setServerData(serverData);

          const localDate = localUpdateTime ? new Date(localUpdateTime) : null;
          const serverDate = serverUpdateTime ? new Date(serverUpdateTime) : null;

          // Conflict case: both have data and server is newer
          if (serverSheetsData && localDate && serverDate && (serverDate > localDate)) {
            setIsConflictModalVisible(true);
            return;
          }
          // Auto-sync if no conflict
          else {
            await updateAllSheets(id, localData);
            removeOfflineData(id);

          }
        } catch (e) {
          console.error('Error during offline sync:', e);
        }
      }
    };

    // Initial check
    handleOfflineStatus();

    window.addEventListener('offline', handleOfflineStatus);
    window.addEventListener('online', handleOfflineStatus);

    return () => {
      window.removeEventListener('offline', handleOfflineStatus);
      window.removeEventListener('online', handleOfflineStatus);
    };

    // isManualOffline re-runs this when the user toggles work-offline from the
    // dashboard, so the banner and the sync decision stay in step.
  }, [id, setSavingData, isManualOffline]);

  if (!offline) return null;

  return (
    <div className="offlineStatus">
      <div>
        {isManualOffline
          ? "You're working offline — changes are saved locally and we'll sync up when you go back online."
          : "No internet? No problem! You're working offline — we'll sync up when you're reconnected."}
      </div>
    </div>
  );
};

export default OfflineStatus;